const formatString = (string: string): string => {
  // Remove whitespaces and convert to lowercase
  return string.replace(/\s+/g, '-').toLowerCase()
}

export default formatString
